import { useMemo } from "react";
import { Link } from "react-router";
import { deepCompact } from "../../../util/helpers";
import { formatDateTime, humanizeString } from "../../../util/formatters";
import { AdministrateTable } from "../../components/AdministrateTable";
import { Routes } from "../../Routes";
import { makeColumns, useAdministrateTable } from "../../utils";

const displayValue = (value) => (value ? humanizeString(value) : "—");

const retrySummary = ({ followUpNumber, pollCount, providerErrorAttemptCount }) =>
  [
    followUpNumber ? `Business attempt ${followUpNumber}` : null,
    pollCount ? `${pollCount} poll${pollCount === 1 ? "" : "s"}` : null,
    providerErrorAttemptCount ? `${providerErrorAttemptCount} provider failure${providerErrorAttemptCount === 1 ? "" : "s"}` : null,
  ]
    .filter(Boolean)
    .join(" · ") || "—";

const useColumns = makeColumns(() => [
  {
    id: "started_at",
    accessor: "startedAt",
    Header: "Timestamp",
    Cell: ({ value }) => formatDateTime(value, "—"),
    disableFilters: true,
  },
  {
    id: "source",
    accessor: "sourceLabel",
    Header: "Source",
    Cell: ({ row, value }) => <Link to={Routes.benefitsDetail.url(row.original.source, row.original.id)}>{value}</Link>,
    disableFilters: true,
  },
  {
    id: "provider",
    accessor: "provider",
    Header: "Provider",
    Cell: ({ value }) => displayValue(value),
    disableFilters: true,
  },
  {
    id: "state",
    accessor: "state",
    Header: "State",
    Cell: ({ value }) => displayValue(value),
    disableFilters: true,
  },
  {
    id: "outcome",
    accessor: "outcome",
    Header: "Outcome",
    Cell: ({ row, value }) => displayValue(value || row.original.errorCategory),
    disableFilters: true,
  },
  {
    id: "retry_information",
    accessor: (record) => retrySummary(record),
    Header: "Retry Information",
    disableFilters: true,
  },
  {
    id: "status_code",
    accessor: "statusCode",
    Header: "Status Code",
    Cell: ({ value }) => value || "—",
    disableFilters: true,
  },
  {
    id: "source_transaction_id",
    accessor: "sourceTransactionId",
    Header: "Transaction ID",
    Cell: ({ value }) => value || "—",
    disableFilters: true,
  },
]);

export const PullBenefitsLogListing = ({ caseId }) => {
  const columns = useColumns();

  const extraParams = useMemo(() => deepCompact({ public_id: caseId }), [caseId]);

  const { tableRef, setTableFilters } = useAdministrateTable(extraParams);

  return (
    <AdministrateTable
      resourceUrl={"/admin/benefits_log.json"}
      extraParams={extraParams}
      resourceName={"benefits_logs"}
      onFilteredChange={setTableFilters}
      columns={columns}
      ref={tableRef}
    />
  );
};
